import service from "../plugins/service"
import { createFormData } from '@/plugins/formData'

export const searchReceiver = o => {
  const data = createFormData(o)

  return service({
    url: `/afterSale/team/query`,
    method: 'POST',
    data
  })
}

export const addOperator = data => {
  return service({
    url: `/afterSale/team/saveOrUpdate`,
    method: 'POST',
    data
  })
}

export const searchOperator = o => {
  const data = createFormData(o)

  return service({
    url: `afterSale/team/query`,
    method: 'POST',
    data
  })
}

export const deleteOperator = o => {
  const data = createFormData(o)

  return service({
    url: `afterSale/team/del`,
    method: 'DELETE',
    data
  })
}

export const distribute = data => {
  return service({
    url: `afterSale/order/rush`,
    method: 'POST',
    data
  })
}

export const searchHelper = o => {
  const data = createFormData(o)

  return service({
    url: `afterSale/team/app/query`,
    method: 'POST',
    data
  })
}